/**
 * useSubscription — the tenant's subscription from GET /users/me/permissions (Phase 13).
 * Null while permissions load, or when an older backend omits the block; callers then show
 * no subscription banners and never block.
 *
 * @module hooks/useSubscription
 */

import { useAuth } from '../context/authcontext';
import type { AccountSubscription } from '../types/permissions';

export const useSubscription = (): AccountSubscription | null => {
  const { user } = useAuth();
  return user?.subscription ?? null;
};

export default useSubscription;
